export const USER_TYPES = {
    Crew: 'Crew',
    Office: 'Office',
} as const;
